import React, { useContext, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import Grid from '@mui/material/Grid';

import {
  Select,
  MenuItem,
  FormControl,
  TextField,
  Paper,
  Box,
  CircularProgress,
  Typography,
} from "@mui/material";
import { useSnackbar } from "notistack";
import ApiService from "../../functions/apiService";
import ButtonTheme from "../../components/ThemeButton/ThemeButton";
import Error from "../../components/Error/Error";
import SystemHeaderNav from "../../components/HeadersNav/SystemHeaderNav";
import AuthContext from "../../context/AuthContext";
import UpdateConfTable from "../../components/System/adminPanelForms/UpdateConfTable";
import ExportConfTable from "../../components/System/adminPanelForms/ExportConfTable";
import ImportConfVariable from "../../components/System/adminPanelForms/ImportConfVariable";
import ImportSelectOption from "../../components/System/adminPanelForms/ImportSelectOption";
// import PhpConf from "../../components/System/adminPanelForms/PhpConf";
import Accruals from "../../components/System/adminPanelForms/Accruals";
import PTOTotals from "../../components/System/adminPanelForms/PTOTotals";
import UserOptionForm from "../../components/System/adminPanelForms/UserOptionForm";
import ResetPasswords from "../../components/System/adminPanelForms/ResetPasswords";
import ResetEmail from "../../components/System/adminPanelForms/ResetEmail";
import EmployeeData from "../../components/System/adminPanelForms/EmployeeData";
import PTOData from "../../components/System/adminPanelForms/PTOData";
import SetLocks from "../../components/System/adminPanelForms/SetLocks";
import ViewActiveLocks from "../../components/System/adminPanelForms/ViewActiveLocks";
import ApiTest from "../../components/System/adminPanelForms/ApiTest";
import DeleteLocks from "../../components/System/adminPanelForms/DeleteLocks";
import CleanData from "../../components/System/adminPanelForms/CleanData";
import OvertimeDetailHours from "../../components/System/adminPanelForms/OvertimeDetailHours";
import UpdateDBStructure from "../../components/System/adminPanelForms/UpdateDBStructure";
import AddStations from "../../components/System/adminPanelForms/AddStations";
import { toast } from 'react-toastify';

export default function AdminPanel() {
  // const { enqueueSnackbar } = useSnackbar();
  const { user } = useContext(AuthContext);
  const [fetching, setFetching] = useState(true);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const {
    register,
    control,
    formState: { errors },
    handleSubmit,
    setError,
    setValue,
    getValues,
    reset,
    watch,
  } = useForm({
    defaultValues: {
      Var: "",
      Value: "",
    },
  });

  useEffect(() => {
    setFetching(true);
    ApiService.get("/getGlobalAdminValues", {}, "getGlobalAdminValues")
      .then(({ data }) => {
        setData(data.data);
        setFetching(false);
      })
      .catch(() => {
        setFetching(false);
        toast.error("Error")
        // enqueueSnackbar("Error", { variant: "error" });
      });
  }, []);
  useEffect(() => {
    if (data && data.configuration) {
      let search = data.configuration.filter((i) => i.Var == watch("Var"));
      if (search.length > 0) {
        setValue("Value", search[0]?.Value);
      }
    }
  }, [watch("Var")]);

  const onSubmit = (body) => {
    setLoading(true);
    ApiService.post("/editSystemConfig", body)
      .then(({ data }) => {
        setLoading(false);
        console.log("data", data);
        toast.success("Success")
        // enqueueSnackbar("success", { variant: "success" });
      })
      .catch(({ data }) => {
        setLoading(false);
        toast.error("Error")
        // enqueueSnackbar("Error", { variant: "error" });
      });
  };

  return (
    <>
      <SystemHeaderNav />
      <Paper className=" p-4" style={{ marginTop: "1rem" }}>
        {fetching && (
          <Box className="w-100 h-100 d-flex justify-content-center align-items-center">
            <CircularProgress />
          </Box>
        )}
        {!fetching && data && (
          <>
            <Grid container spacing={2}>
              <Grid size={4} md={4} sm={12}>
                <div style={{
                  padding: '16px',
                  margin: '10px',
                  backgroundColor: 'rgb(255, 255, 255)',
                  height: '150px',
                  borderRadius: '12px',
                  border: '1px solid rgb(235, 236, 240)',
                  boxShadow: 'rgba(31, 64, 148, 0.02) 0px 3.26px 9.79px, rgba(22, 38, 61, 0.06) 0px 6.53px 7.18px, rgba(4, 43, 141, 0.03) 0px 1.96px 3.92px'
                }}>
                  <Typography fontWeight="700" fontSize="20px" sx={{ borderBottom: '1px solid #f5f5f5', paddingBottom: '8px' }}>
                    Global Administration
                  </Typography>
                  <div className="my-2">
                    <Typography fontWeight="500" fontSize="16px">
                      Database: {data?.database}
                    </Typography>
                    <Typography fontWeight="500" fontSize="16px">
                      Employee: {user?.employee_assignment?.EA_Rank} {user?.fullName}
                    </Typography>
                  </div>
                </div>
              </Grid>
              <Grid size={4} md={4} sm={12}>
                <div style={{
                  padding: '16px',
                  margin: '10px',
                  backgroundColor: 'rgb(255, 255, 255)',
                  height: '150px',
                  borderRadius: '12px',
                  border: '1px solid rgb(235, 236, 240)',
                  boxShadow: 'rgba(31, 64, 148, 0.02) 0px 3.26px 9.79px, rgba(22, 38, 61, 0.06) 0px 6.53px 7.18px, rgba(4, 43, 141, 0.03) 0px 1.96px 3.92px'
                }}>
                  <Typography fontWeight="700" fontSize="20px" sx={{ borderBottom: '1px solid #f5f5f5', paddingBottom: '8px' }}>
                    Server
                  </Typography>
                  <div className="my-2">
                    <Typography fontWeight="500" fontSize="16px">
                      Server: {data?.server}
                    </Typography>
                    <Typography fontWeight="500" fontSize="16px">
                      Timestamp: {data?.timestamp_timezone}
                    </Typography>
                  </div>
                </div>
              </Grid>
              <Grid size={4} md={4} sm={12}>
                <div style={{
                  padding: '16px',
                  margin: '10px',
                  backgroundColor: 'rgb(255, 255, 255)',
                  height: '150px',
                  borderRadius: '12px',
                  border: '1px solid rgb(235, 236, 240)',
                  boxShadow: 'rgba(31, 64, 148, 0.02) 0px 3.26px 9.79px, rgba(22, 38, 61, 0.06) 0px 6.53px 7.18px, rgba(4, 43, 141, 0.03) 0px 1.96px 3.92px'
                }}>
                  <Typography fontWeight="700" fontSize="20px" sx={{ borderBottom: '1px solid #f5f5f5', paddingBottom: '8px' }}>
                    User Agent
                  </Typography>
                  <div className="my-2">
                    <Typography fontWeight="500" fontSize="16px">
                      {data?.user_agent}
                    </Typography>
                    <Typography fontWeight="500" fontSize="16px">
                      {data?.user_agent_simple}
                    </Typography>
                  </div>
                </div>
              </Grid>
            </Grid>


            <div className="my-3">
              <Typography fontWeight="700" fontSize="20px">
                Configuration
              </Typography>
              <Typography fontWeight="500" fontSize="16px">
                Update _Config Variables
              </Typography>
            </div>
            <form onSubmit={handleSubmit(onSubmit)} className="row">
              <div className="col-12 col-md-6">
                <FormControl margin="dense" required={true} fullWidth>
                  <label>Var</label>
                  <Select
                    className="mt-2"
                    {...register("Var", { required: "Var  is required." })}
                    sx={{
                      height: '48px',
                    }}
                  >
                    {data.configuration &&
                      data.configuration.map((i) => (
                        <MenuItem value={i.Var} key={i.Var}>
                          {i.Var}
                        </MenuItem>
                      ))}
                  </Select>
                  {errors.Var && <Error>{errors.Var?.message}</Error>}
                </FormControl>
              </div>
              <div className="col-12 col-md-6">
                <FormControl margin="dense" required={true} fullWidth>
                  <label>Value</label>
                  <TextField
                    className="mt-2"
                    {...register("Value", {
                      required: "Value  is required.",
                    })}
                    InputProps={{
                      sx: {
                        height: '48px',
                      }
                    }}
                  />
                  {errors.Value && <Error>{errors.Value?.message}</Error>}
                </FormControl>
              </div>
              <div className="col-12">
                <ButtonTheme disabled={loading} type="submit" color="primary" className='mt-2'>
                  Save
                </ButtonTheme>
              </div>
            </form>

            <Grid container className="my-4">
              <Grid item xs={6}>
                <UpdateConfTable />
              </Grid>
              <Grid item xs={6}>
                <ExportConfTable />
              </Grid>
            </Grid>


            <hr />



            <div className="my-2">
              <h5>Employees</h5>
              <Accruals />
              <br />
              <PTOTotals />
              <br />
              <UserOptionForm />
              <br />
              <ResetPasswords />
              <br />
              <ResetEmail />
              <br />
              <EmployeeData />
              <br />
              <PTOData />
            </div>
            <hr />
            <div className="my-2">
              <SetLocks />
              <br />
              <hr />
              <ViewActiveLocks />
              {/* <br />
                        <hr />
                        <ApiTest /> */}
              <br />
              <hr />
              <DeleteLocks />
              {/* <br />
                        <hr />
                        <CleanData /> */}
            </div>
            <hr />
            <div className="my-2">
              <h5>Overtime & Detail Hours</h5>
              <OvertimeDetailHours />
              <hr />
              <UpdateDBStructure />
              <hr />
              <AddStations />
            </div>
          </>
        )}
      </Paper>
    </>
  );
}
